import api from './api';
import qs from "qs";

const QuestionarioService = {
    buscar: (idsQuestionarios) => {
        return api.get("/questionario", {
            params: {idsQuestionarios},
            paramsSerializer: params => qs.stringify(params, {arrayformat: 'repeat'})
        });
    },
    buscarRespostas: (idTicket, idsQuestionarios) => {
        return api.get(`/questionario/ticket/${idTicket}/respostas`, {
            params: {idsQuestionarios},
            paramsSerializer: params => qs.stringify(params, {arrayformat: 'repeat'})
        });
    },
    store: (dados) => {
        let uri = `/questionario`;
        return api["post"].call(api, uri, dados);
    },
    update: (id, dados) => {
        let uri = "/questionario/" + id;
        return api["put"].call(api, uri, dados);
    },
    delete: (id) => {
        let uri = "/questionario/" + id;
        return api["delete"].call(api, uri);
    },
    alterarStatusPergunta: (idQuestionario, idPergunta, dados) => {
        let uri = `/questionario/${idQuestionario}/pergunta/${idPergunta}`;
        return api["put"].call(api, uri, dados);
    },
    deletePergunta: (idQuestionario, idPergunta) => {
        let uri = `/questionario/${idQuestionario}/pergunta/${idPergunta}`;
        return api["delete"].call(api, uri);
    },
    addPerguntasQuestionario: (idQuestionario, dados) => {
        let uri = `/questionario/${idQuestionario}/perguntas`;
        return api["post"].call(api, uri, dados);
    },
    reordenarPerguntasQuestionario: (idQuestionario, ordem) => {
        let uri = `/questionario/${idQuestionario}/perguntas`;
        return api["put"].call(api, uri, { ordem });
    },    
    buscarQuestionariosPorTicket: (idTicket, idEmpreendimento) => {
        let uri = `questionario/ticket/${idTicket}${idEmpreendimento ? `/empreendimento/${idEmpreendimento}` : ""}`;
        return api["get"].call(api, uri);
    },
    buscarPermissoes: ()=>{
        let uri = `questionario/ticket/permissoes`;
        return api['get'].call(api, uri);
    },
    exportarResultados: (idQuestionario)=>{
        let uri = `questionario/${idQuestionario}/resultados`;
        return api['get'].call(api, uri);
    },
    storeRespostasQuestionario: (idOportunidade, idQuestionario, respostas) => {
        let uri = `resposta/oportunidade/${idOportunidade}/questionario/${idQuestionario}`;
        return api["post"].call(api, uri, { respostas });
    },
    buscarRespostasPorOportunidade: (idOportunidade) => {
        let uri = `resposta/oportunidade/${idOportunidade}`;
        return api["get"].call(api, uri);
    },
    gerarLinkPublico: (dados)=>{
        let uri = `questionario-publico`;
        return api["post"].call(api, uri, dados);
    },
    buscarQuestionariosPublicosTicket: (idTicket, idQuestionario)=>{
        let uri = `questionario-publico/ticket/${idTicket}/questionario/${idQuestionario}`;
        return api["get"].call(api, uri);
    },
    removerQuestionarioPublico: (idQuestionarioPublico)=>{
        let uri = `questionario-publico/${idQuestionarioPublico}`;
        return api["delete"].call(api, uri);
    },
    buscarTemplatesPorMeioComunicacao: (meioComunicacao)=>{
        let uri = `questionario-publico/template/meio-comunicacao/${meioComunicacao}`;
        return api['get'].call(api, uri);        
    },
    dispararLinkproponentes: (dados)=>{
        let uri = `questionario-publico/disparo-proponentes`;
        return api['post'].call(api, uri, dados);
    },
};

export default QuestionarioService;
